module.exports = __webpack_public_path__ + "img/jtys-active.d896aafc.svg";